// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const ReleaseNotesTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensReleaseNotes.releaseNotesTitle"
        description="Release notes title."
        defaultMessage="Release Notes"
    />
);
ReleaseNotesTitle.displayName = "ReleaseNotesTitle";

export const ReleaseNotesError = (): ReactElement => (
    <FormattedMessage
        id="apps.lensReleaseNotes.releaseNotesError"
        description="Release notes error."
        defaultMessage="Error fetching release notes."
    />
);
ReleaseNotesError.displayName = "ReleaseNotesError";

export const NoReleaseNotes = (): ReactElement => (
    <FormattedMessage
        id="apps.lensReleaseNotes.noReleaseNotes"
        description="No release notes."
        defaultMessage="No release notes found."
    />
);
NoReleaseNotes.displayName = "NoReleaseNotes";
